import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set page title and meta description
document.title = 'XMonsters Agency - Modern Websites for €299 | Free Demo First';
const metaDescription = document.querySelector('meta[name="description"]');
if (metaDescription) {
  metaDescription.setAttribute('content', 'Get a professional website for just €299. Free demo preview first - pay only if you want to launch. Modern design, mobile-friendly, worldwide service.');
} else {
  const meta = document.createElement('meta');
  meta.name = 'description';
  meta.content = 'Get a professional website for just €299. Free demo preview first - pay only if you want to launch. Modern design, mobile-friendly, worldwide service.';
  document.head.appendChild(meta);
}
// Add Open Graph tags
const ogTags = [{
  property: 'og:title',
  content: 'XMonsters Agency - Modern Websites for €299'
}, {
  property: 'og:description',
  content: 'Get a professional website for just €299. Free demo preview first - pay only if you want to launch.'
}, {
  property: 'og:type',
  content: 'website'
}, {
  property: 'og:image',
  content: 'https://xmonsters.agency/og-image.jpg'
}];
ogTags.forEach(tag => {
  const existing = document.querySelector(`meta[property="${tag.property}"]`);
  if (existing) {
    existing.setAttribute('content', tag.content);
  } else {
    const meta = document.createElement('meta');
    meta.setAttribute('property', tag.property);
    meta.content = tag.content;
    document.head.appendChild(meta);
  }
});
render(<App data-id="element-285" />, document.getElementById('root'));